/* ==========================================================================
   TOP コンセプトブロック 演出制御（concept-*）
   - GSAP + ScrollTrigger（CDNでグローバル読込済み / register は main.js 済み）
   - Lenis は main.js でインスタンス化＆ ScrollTrigger と全域連携済み
     （lenis.on('scroll', ScrollTrigger.update) + raf統合）。
     本ファイルは ScrollTrigger を使うだけで同期されるため lenis 参照は不要。
   - 既存の Lenis / ScrollTrigger のグローバル設定は一切変更しない。
   ========================================================================== */
(function () {
  "use strict";

  if (!window.gsap || !window.ScrollTrigger) return;

  var gsap = window.gsap;
  var ScrollTrigger = window.ScrollTrigger;

  // register 済み想定だが、念のため冪等に保証（既存設定は壊さない）
  if (gsap.core && typeof gsap.registerPlugin === "function") {
    gsap.registerPlugin(ScrollTrigger);
  }

  function init() {
    var section = document.querySelector("[data-concept-block]");
    if (!section) return;

    var pin = section.querySelector("[data-concept-pin]");
    var bg = section.querySelector("[data-concept-bg]");
    var overlay = section.querySelector("[data-concept-overlay]");
    var logo = section.querySelector("[data-concept-logo]");
    var intro = section.querySelector("[data-concept-intro]");
    var headline = section.querySelector("[data-concept-headline]");
    var subhead = section.querySelector("[data-concept-subhead]");
    var text = section.querySelector("[data-concept-text]");
    // CTA は現在 HTML 側でコメントアウト中（存在しない場合は null）
    var cta = section.querySelector("[data-concept-cta]");

    var items = [logo, headline, subhead, text, cta].filter(Boolean);
    if (!items.length) return;

    // JS有効フラグ（CSSの初期非表示を有効化）
    document.documentElement.classList.add("concept-js");

    // このセクション専用に matchMedia をスコープ（他セクションに干渉しない）
    var mm = gsap.matchMedia(section);

    mm.add(
      {
        isDesktop: "(min-width: 641px)",
        isMobile: "(max-width: 640px)",
        reduceMotion: "(prefers-reduced-motion: reduce)",
      },
      function (ctx) {
        var c = ctx.conditions;

        // ---- 動きを抑える設定：静的表示のみ ----
        if (c.reduceMotion) {
          gsap.set(items, { opacity: 1, y: 0, filter: "none", clearProps: "filter" });
          gsap.set(overlay, { opacity: 0.45 });
          return;
        }

        // ---- モバイル：pin/scrub を使わず縦積みで順次フェード ----
        if (c.isMobile) {
          gsap.set(overlay, { opacity: 0.42 });
          items.forEach(function (el) {
            gsap.set(el, { opacity: 0, y: 32 });
            gsap.to(el, {
              opacity: 1,
              y: 0,
              duration: 0.9,
              ease: "power2.out",
              scrollTrigger: {
                trigger: el,
                start: "top 88%",
                toggleActions: "play none none reverse",
              },
            });
          });
          return;
        }

        // ---- デスクトップ：pin + scrub のシネマティック演出 ----
        gsap.set(items, { opacity: 0, y: 44, filter: "blur(8px)" });
        gsap.set(overlay, { opacity: 0 });
        gsap.set(bg, { scale: 1.04 });

        var tl = gsap.timeline({
          defaults: { ease: "power2.out" },
          scrollTrigger: {
            trigger: section,
            start: "top top",
            end: function () {
              return "+=" + window.innerHeight * 4.5;
            },
            pin: pin,
            pinSpacing: true,
            scrub: 1,
            anticipatePin: 1,
            invalidateOnRefresh: true,
          },
        });

        // ① ロゴ：中央フェードイン（表示は維持）
        tl.to(logo, { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.0 })
          .to({}, { duration: 0.5 }); // 間

        // ② ロゴはそのまま、その下にキャッチ（ヘッドライン＋サブ）が登場
        tl.to(headline, { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.0 }, "catch")
          .to(subhead, { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.0 }, "catch+=0.25")
          .to({}, { duration: 1.0 }); // ロゴ＋キャッチ両方を見せる余韻

        // ③ ロゴ＋キャッチがまとめて退場 → 詳細テキスト登場（同時に背景を暗転）
        tl.to(intro, { opacity: 0, y: -30, filter: "blur(6px)", duration: 0.9, ease: "power2.in" }, "toText")
          .to(text, { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.1 }, "toText+=0.25")
          .to(overlay, { opacity: 0.68, duration: 1.4, ease: "power1.inOut" }, "toText")
          .to(bg, { scale: 1.08, duration: 1.6, ease: "none" }, "toText")
          .to({}, { duration: 1.1 }); // 余韻（最も暗い区間を保持）

        // ⑤ ボタン（現在は非表示。HTMLコメント解除時に自動でタイムライン末尾へ追加される）
        if (cta) {
          tl.to(cta, { opacity: 1, y: 0, filter: "blur(0px)", duration: 0.9 }, ">-0.2");
        }
      }
    );

    // 背景画像の読み込み完了後に pin 位置を再計算（ずれ防止）
    var bgSrc = bg && bg.getAttribute("data-concept-bg-src");
    if (bgSrc) {
      var preload = new Image();
      preload.onload = function () {
        ScrollTrigger.refresh();
      };
      preload.onerror = function () {
        ScrollTrigger.refresh();
      };
      preload.src = bgSrc;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
